<template>
<div>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :close-on-press-escape="false"
    :show-close="false"
    class="login-dialog-container"
    top="14vh"
    custom-class="login-wrap"
    @close="close"
  >
    <div class="login-content">
      <div class="login-title">
        <p class="normal-title">使用手機號登入</p>
      </div>
      <div class="login-body">
        <div class="login-body-line mobile">
          <div
            class="mobile-prefix"
          >
            <el-popover
              v-model="isShowMobileAreaSelectList"
              :visible-arrow="false"
              popper-class="popper-clear-style"
              placement="bottom-start"
            >
              <div slot="reference" class="mobile-prefix-inner">
                <span>{{ currentSelectPrefix.code }}</span>
                <img src="~@/assets/images/select-icon.png" alt="" />
              </div>
              <div
                class="login-dialog-body-mobile-area"
              >
                <p
                  v-for="(item, index) in mobileAreaList"
                  :key="index"
                  @click="selectMobileArea(item.code)"
                >
                  <span>{{ item.text }}</span>
                  <span>{{ item.code }}</span>
                </p>
              </div>
            </el-popover>
          </div>
          <div class="mobile-input">
            <input v-model="loginObj.phoneNumber" type="text" placeholder="請輸入手機號碼" />
          </div>
        </div>
        <div class="login-body-line code">
          <div class="valid-code">
            <input v-model="loginObj.verifyCode" type="text" placeholder="請輸入認證碼" />
          </div>
          <div class="btn">
            <button
              :class="!sendCodeTimer && !isSendingSmsCode && 'button-hover'"
              :disabled="sendCodeTimer > 0"
              @click="getValidateCode"
            >
              <span v-if="isSendingSmsCode">
                <i class="el-icon-loading"></i>
                發送中
              </span>
              <span v-else>{{ sendCodeTimer > 0 ? '重新傳送(' + sendCodeTimer + ')' : '獲取認證碼' }}</span>
            </button>
          </div>
        </div>
        <div class="login-body-operation">
          <p @click="changeIsKeepLoginStatus">
            <el-checkbox class="remember-check" :value="isKeepLoginStatus" @change="changeIsKeepLoginStatus"></el-checkbox>
            <!-- <img :src="isKeepLoginStatus ? 'checked' : 'unchecked'" alt=""> -->
            <span>記住登入</span>
          </p>
        </div>
      </div>
    </div>
    <div class="login-footer">
      <button @click="login" class="primary-btn">
        <i class="el-icon-loading" v-if="isLogining"></i>
        <span v-else>立即登入</span>
      </button>
        <div class="other-login" @click.stop="thirdParyLogin()" v-if="allowThirdParyLogin">選擇其他方式登陸</div>
    </div>

    <!-- <div class="login-protocol">
      <p>登入即代表您同意<span @click="jumpPage('/privacy')">nicee服務協議與隱私權條款</span></p>
    </div> -->
    <div id="verification-code"></div>
    <!-- <i @click="close" class="close-btn"></i> -->
  </el-dialog>
</div>
</template>
<script>
import store from '@/store/index'
import { getSmsCode } from '@/api'
import mobileAreaList from '@/utils/areas-code'
import Clickoutside from "@/utils/clickoutside"
// import axios from 'axios'
// let unLoginAB

export default {
  name: 'phoneLogin',
  directives: {
    clickoutside: Clickoutside
  },
  data() {
    return {
      isKeepLoginStatus: true,
      isShowMobileAreaSelectList: false,
      mobileAreaList: mobileAreaList,
      currentSelectPrefix: {
        code: 886
      },
      isSendingSmsCode: false,
      isLogining: false,
      sendCodeTimer: 0,
      // visible: false,
      chatAvatar: '',
      isHome: false,
      brandSocialTest: '',
      brandGamingTest: '',
      isSix: false,
      isBanner: false,
      loginObj: {
        phoneNumber: '',
        verifyCode: '',
        keyUuid: null,
        isHome: false,
        brandSocialTest: '',
        brandGamingTest: '',
        isBanner: false,
      },
      tencentCaptchaInstance: null,
      timer:null,
      isClickOrder: false
    }
  },
  props:{
    phoneLoginDialog:{
      type: Boolean,
      default:false
    },
    pagelogin: {
      type: Boolean,
      default:false
    },
    redirect: {
      type: String,
      default:''
    },
    allowThirdParyLogin: {
      type: Boolean,
      default:false
    },
    inviterUuid:String
  },
  computed: {
    visible: {
      get: function() {
        return this.phoneLoginDialog
      },
      set: function() {
        // this.$emit('close',false)
      }
    }
  },
  watch: {
    phoneLoginDialog(show) {
      if (show) {
        this.$adjust('login_page_btn_click', {
          source: 'phone'
        })
      }
    }
  },
  methods: {
    thirdParyLogin() {
      this.$emit('thirdParyLogin',true)
    },
    close() {
      this.$emit('closePhoneLogin',false)
    },
    jumpPage(page) {
      this.$util.openWindow(page)
    },
    /**
     * @description 是否记住登录状态
     */
    changeIsKeepLoginStatus() {
      this.isKeepLoginStatus = !this.isKeepLoginStatus
    },
    toggleMobileAreaSelectList() {
      this.isShowMobileAreaSelectList = !this.isShowMobileAreaSelectList
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
    /**
     * @description 獲取驗證碼
     */
    getValidateCode() {
      // 获取验证码按钮点击埋点
      // window.gtag('tel_accept_code_click', 0)
      const { phoneNumber } = this.loginObj
      if (!phoneNumber) return this.$message.error('請輸入手機號碼')
      if (!this.tencentCaptchaInstance) {
        this.getSlidDomTime()
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            const { phoneNumber } = this.loginObj
            const { code } = this.currentSelectPrefix
      
            getSmsCode({
              phoneNumber: code + phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }

              this.isSendingSmsCode = false
            }).catch(err => {
              this.isSendingSmsCode = false
              if (err.msg) {
                if (err.msg === 'InvalidParameterValue.IncorrectPhoneNumber') {
                  this.$message.error('手機號格式錯誤')
                  return
                }
                this.$message.error(err.msg)
              }
            })
          }
        })
      }

      this.tencentCaptchaInstance.show()
    },
    getSlidDomTime() {
      // let beforeSlidShow = new Date().getTime()
      let codeIframe = document.getElementById('tcaptcha_iframe');

      if(!codeIframe) {
        setTimeout(() => {
          this.getSlidDomTime()
        }, 100);
        return
      }
      // codeIframe.onload = function(){
      //   let afterSlidShow = new Date().getTime()
      //   let slidDomTime = afterSlidShow - beforeSlidShow
      //   axios.get('https://www.cloudflare.com/cdn-cgi/trace').then(({data})=>{
      //     gtag('SlidDomTime', slidDomTime, data)
      //   })
      // };
    },
    /**
     * @description 設置發送驗證碼倒計時
     */
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count
      clearTimeout(this.timer)
      if (count > 0) {
        this.timer = setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      }
    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      const { phoneNumber, verifyCode, keyUuid } = this.loginObj
      const { code } = this.currentSelectPrefix
      if (!phoneNumber) {
        this.$message.error('請輸入正確的手機號碼')
        return false
      }
      if (verifyCode.length !== 4) {
        this.$message.error('認證碼錯誤')
        return false
      }


      //inviterUnique字段接口變更用作註冊領取專屬陪玩師紅包用
      let inviterUnique = this.inviterUuid || window.localStorage.getItem('STORAGE_INVITER_UUID') || null
      if (!inviterUnique) {
        const str = sessionStorage.getItem('INVITE_UNIQUE')
        str && (inviterUnique = JSON.parse(str).inviterUnique)
      }

      return {
        phoneNumber: code + phoneNumber,
        verifyCode,
        keyUuid,
        isSaveToken: this.isKeepLoginStatus,
        isHome: this.isHome,
        brandSocialTest: this.brandSocialTest,
        brandGamingTest: this.brandGamingTest,
        isBanner: this.isBanner,
        inviterUnique, // 普通用户的拉稀邀请邀请码
        signUpUniqueCode: this.$route.params.inviteCode // 签约用户的拉新邀请邀请码
      }
    },
    /**
     * @description 登陸
     */
    async login() {
      if(this.isHome) {
        // window.gtag('Login', 'FreeGame', 'Profile')
      }
      if(this.isBanner) {
        // window.gtag('Login', 'FreeGame', 'Banner')
      }
      // unLoginAB = window.localStorage.getItem('unLoginHomeABTest')
      // window.gtag('signupab_phone', unLoginAB)
      const params = this.validateInputMsg()
      if (params && !this.isLogining) {
        this.isLogining = true
        // window.gtag('Click', 'Login', 'Dialog')
        if(this.isSix) {
          // window.gtag('Login', 'JoinWall', 'Max_5')
        }
        try {
          await store.dispatch('app/login', params)
          this.isLogining = false
          this.$emit('closePhoneLogin',false)
          this.isEmpty()
          this.beforeSuccess()
        } catch(e) {
          this.isLogining = false
        }
      }
    },
    beforeSuccess(params) {
      let isLogin = false
      const userInfo = store.getters.userInfo
      if (params && params.isThirdpary && params.isLogin) {
        isLogin = true
      }
      if (!params) {
        if (userInfo.isNewRegistration) {
          this.$adjust('web_activate_success', {type: 'phone'})
          // store.dispatch('master/guideSelect', true)
          if(userInfo.phoneNumber.substring(0, 3) !== '886') {
            this.$message({
              message: '很遺憾，目前新人優惠券只支持台灣地區的手機號'
            })
          } else if (!userInfo.hasRedBag) {
            this.$message({
              message: '每個用戶註冊後只有一次使用新人優惠券機會喔'
            })
          }
        } else {
          isLogin = true
        }
      }
      // window.gtag('signupab_phone_success', unLoginAB)
      this.success({ isLogin,redirect:this.redirect })
    },
    success(params) {
      this.$emit('successLogin', params);
    },
    isEmpty(){
      this.loginObj.verifyCode = ''
      this.setSmsCodeInterval(0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .button-hover:hover {
    background: #FEE060 !important;
  }
  
.login-footer {
  margin: 20px auto 0;
  .other-login {
    margin-top: 12px;
    padding-left: 6px;
  }
}
  
  @media screen and (min-width: 600px) {

    .login-dialog-container {
      & /deep/ .el-dialog{
        width: 386px;
        border-radius: 8px;
      }
      & /deep/ .el-dialog__header {
        padding: 0;
      }

      & /deep/ .el-dialog__body {
        padding-bottom: 30px;
      }
    }
    .login-wrap {
      height: 422px;
      padding: 30px 20px 50px;

      .login-title {
        color: #333;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        .chat-text {
          width: 170px;
          text-align: left;
        }
        img {
          width: 58px;
          height: 58px;
          border-radius: 100%;
          margin-right: 15px;
        }
      }
      .login-gift {
        display: flex;
        justify-content: center;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        text-align: center;
        color: #82BE2F;
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .login-body {
        position: relative;
        padding: 30px 28px 0;
        // border-top: 1px solid #e0e0e0;
      }

      .login-footer {
        margin: 20px auto 0;

        button {
          @include flex();
          width: 290px;
          height: 46px;
          margin: auto;
        }
        .other-login {
          padding-left:28px
        }
      }
      .close-btn {
        display: block;
        position: absolute;
        width: 37px;
        height: 37px;
        bottom: -100px;
        left: 170px;
        background: url('~@/assets/image/icons/close-icon-border.png') no-repeat center center;
        background-size: contain;
        cursor: pointer;
      }
      .login-protocol {
        font-size: 13px;
        line-height: 18px;
        color: #666;
        text-align: center;

        span {
          cursor: pointer;
          text-decoration: underline;
          color: #FA006E;
        }
      }

      .login-body-line {
        @include flex();
        height: 46px;
        border-radius: 4px;
        font-size: 16px;

        > div {
          @include flex();
          height: 100%;
        }

        &.mobile {
          border: 1px solid #999999;
          padding: 0 13px 0 0;
        }

        &.code {
          margin-top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          color: #333;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }

        .mobile-prefix {
          width: 55px;
          flex-shrink: 0;
          cursor: pointer;

          .mobile-prefix-inner {
            @include flex(space-between);
            width: 58px;
            padding-left: 13px;
            span {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
              white-space: nowrap;
            }
          }

          img {
            width: 10px;
            margin-left: 2px;
          }
        }

        .mobile-input {
          flex-grow: 1;
          margin-left: 14px;
          input{
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
          }
        }

        .valid-code {
          width: 164px;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 13px;
        }

        .btn {
          width: 116px;
          margin-left: 10px;

          button {
            @include flex();
            width: 100%;
            height: 100%;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px; 
            border-radius: 4px;
            cursor: pointer;
            background: $color-yellow;
            color: $color-gray-1;
            &:disabled {
              background: #FFEC9B !important;
              color: rgba(34, 44, 67, 0.3) !important;
            }
          }
        }
      }

      .login-body-operation {
        display: inline-block;
        font-size: 0;
        margin-top: 39px;

        p {
          @include flex(flex-start);
          cursor: pointer;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }

        span {
          margin-left: 8px;
          font-size: 13px;
          color: #666;
          line-height: 18px;
        }
      }
    }

    .login-dialog-body-mobile-area {
      width: 290px;
      height: 228px;
      overflow: auto;
      border-radius: 4px;
      border: 1px solid #999;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

      p {
        @include flex(space-between);
        color: #333;
        font-size: 16px;
        height: 38px;
        margin: 0;
        padding: 0 9px;
        font-weight: 400;
        transition: all .2s ease;
        cursor: pointer;
        background: white;

        &:hover {
          background: #f6f6f6;
        }

        span:first-child {
          @include ellipsis;
        }
      }
    }


    .login-body-mobile-area {
      width: 290px;
      height: 228px;
      overflow: auto;
      border-radius: 4px;
      border: 1px solid #999;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

      p {
        @include flex(space-between);
        color: #333;
        font-size: 16px;
        height: 38px;
        margin: 0;
        padding: 0 9px;
        font-weight: 400;
        transition: all 0.2s ease;
        cursor: pointer;
        background: white;

        &:hover {
          background: #f6f6f6;
        }

        span:first-child {
          @include ellipsis;
        }
      }
    }
    .thirdpary {
      &.login-body {
        position: relative;
        width: 290px;
        margin: 34px auto 0;
        // border-top: 1px solid #e0e0e0;
      }
      .login-body-line {
        @include flex();
        height: 46px;
        border-radius: 4px;
        font-size: 16px;

        > div {
          @include flex();
          height: 100%;
        }

        &.mobile {
          border: 1px solid #999999;
          padding: 0 13px 0 0;
        }

        &.code {
          margin-top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          color: #333;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }

        .mobile-prefix {
          width: 55px;
          flex-shrink: 0;
          cursor: pointer;

          .mobile-prefix-inner {
            @include flex(space-between);
            width: 58px;
            padding-left: 13px;
            span {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
            }
          }

          img {
            width: 10px;
            margin-left: 2px;
          }
        }

        .mobile-input {
          flex-grow: 1;
          margin-left: 14px;
          input{
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
          }
        }

        .valid-code {
          width: 164px;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 13px;
        }

        .btn {
          width: 116px;
          margin-left: 10px;

          button {
            @include flex();
            width: 100%;
            height: 100%;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            border-radius: 4px;
            cursor: pointer;
            background: $color-yellow;
            color: $color-gray-1;
            &:disabled {
              background: #FFEC9B !important;
              color: rgba(34, 44, 67, 0.3) !important;
            }
          }
        }
      }
    }

  }
  
  @media screen and (max-width: 599px) {
    .dialog-msg {
      font-size: 15px;
      line-height: 21px;
    }
    .login-dialog-container {
      & /deep/ .el-dialog{
        width: 343px !important;
        max-width: 91vw;
        border-radius: 8px;
      }
      & /deep/ .el-dialog__header {
        padding: 0;
      }

      & /deep/ .el-dialog__body {
        padding-bottom: 30px;
        box-sizing: border-box;
      }
    }
    .login-wrap {
      height: 422px;
      .login-title {
        color: #333;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        p {
          width: 170px;
          text-align: center;
          text-align: left;
        }
        .normal-title {
          text-align: center;
        }
        img {
          width: 58px;
          height: 58px;
          border-radius: 100%;
          margin-right: 15px;
        }
      }
      .login-gift {
        display: flex;
        justify-content: center;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        text-align: center;
        color: #82BE2F;
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .login-body {
        position: relative;
        padding: 30px 7px 0 6px;
        box-sizing: border-box;
        // border-top: 1px solid #e0e0e0;
      }

      .login-footer {
        margin: 20px auto 0;
        button {
          @include flex();
          width: 76vw;
          max-width: 290px;
          height: 46px;
          margin: auto;
        }
      }


      .login-protocol {
        font-size: 13px;
        line-height: 18px;
        color: #666;
        text-align: center;

        span {
          cursor: pointer;
          text-decoration: underline;
          color: #FA006E;
        }
      }
      .close-btn {
        display: block;
        position: absolute;
        width: 37px;
        height: 37px;
        bottom: -100px;
        left: 148px;
        background: url('~@/assets/image/icons/close-icon-border.png') no-repeat center center;
        background-size: contain;
        cursor: pointer;
      }
      .login-body-line {
        @include flex(space-between,center,row);
        height: 46px;
        border-radius: 4px;
        font-size: 16px;

        > div {
          @include flex();
          height: 100%;
        }

        &.mobile {
          border: 1px solid #999999;
          padding: 0 13px 0 0;
        }

        &.code {
          margin-top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          color: #333;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }

        .mobile-prefix {
          width: 55px;
          flex-shrink: 0;
          cursor: pointer;

          .mobile-prefix-inner {
            @include flex(space-between);
            width: 58px;
            padding-left: 13px;
            span {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
            }
          }

          img {
            width: 10px;
            margin-left: 2px;
          }
        }

        .mobile-input {
          flex-grow: 1;
          margin-left: 14px;
          input{
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
          }
        }

        .valid-code {
          width: 48vw;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 13px;
        }

        .btn {
          width: 34vw;
          margin-left: 10px;

          button {
            @include flex();
            width: 100%;
            height: 100%;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px; 
            border-radius: 4px;
            cursor: pointer;
            background: $color-yellow;
            color: $color-gray-1;
            &:disabled {
              background: #FFEC9B !important;
              color: rgba(34, 44, 67, 0.3) !important;
            }
          }
        }
      }

      .login-body-operation {
        display: inline-block;
        font-size: 0;
        margin-top: 39px;

        p {
          @include flex(flex-start);
          cursor: pointer;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }

        span {
          font-size: 13px;
          color: #666;
          line-height: 18px;
        }
      }
    }

    .login-dialog-body-mobile-area {
      width: 290px;
      max-width: 77vw;
      height: 228px;
      overflow: auto;
      border-radius: 4px;
      border: 1px solid #999;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: 320px) {
        width: 75vw;
      }
      p {
        @include flex(space-between);
        color: #333;
        font-size: 16px;
        height: 38px;
        margin: 0;
        padding: 0 9px;
        font-weight: 400;
        transition: all .2s ease;
        cursor: pointer;
        background: white;

        &:hover {
          background: #f6f6f6;
        }

        span:first-child {
          @include ellipsis;
        }
      }
    }

    .login-body-mobile-area {
      width: 290px;
      max-width: 77vw;
      height: 228px;
      overflow: auto;
      border-radius: 4px;
      border: 1px solid #999;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: 320px) {
        width: 75vw;
      }
      p {
        @include flex(space-between);
        color: #333;
        font-size: 16px;
        height: 38px;
        margin: 0;
        padding: 0 9px;
        font-weight: 400;
        transition: all 0.2s ease;
        cursor: pointer;
        background: white;

        &:hover {
          background: #f6f6f6;
        }

        span:first-child {
          @include ellipsis;
        }
      }
    }
    .thirdpary {
      &.login-body {
        position: relative;
        padding: 30px 28px 0;
        // border-top: 1px solid #e0e0e0;
      }
      .login-body-line {
        @include flex(space-between,center,row);
        height: 46px;
        border-radius: 4px;
        font-size: 16px;

        > div {
          @include flex();
          height: 100%;
        }

        &.mobile {
          border: 1px solid #999999;
          padding: 0 13px 0 0;
        }

        &.code {
          margin-top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          color: #333;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }

        .mobile-prefix {
          position: relative;
          width: 55px;
          flex-shrink: 0;
          cursor: pointer;

          .mobile-prefix-inner {
            @include flex(space-between);
            width: 58px;
            padding-left: 13px;
            span {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
            }
          }

          img {
            width: 10px;
            margin-left: 2px;
          }
        }

        .mobile-input {
          flex-grow: 1;
          margin-left: 14px;
          input{
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
          }
        }

        .valid-code {
          width: 48vw;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 13px;
        }

        .btn {
          width: 34vw;
          margin-left: 10px;

          button {
            @include flex();
            width: 100%;
            height: 100%;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            border-radius: 4px;
            cursor: pointer;
            background: $color-yellow;
            color: $color-gray-1;
            &:disabled {
              background: #FFEC9B !important;
              color: rgba(34, 44, 67, 0.3) !important;
            }
          }
        }
      }
    }
  }
  .remember-check {
    margin-right: 4px;
  }
</style>
